import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import ByClassFilter from "app/components/commonSeperateMultipleFilter/ByClassFilter";

const CertificateHeader = ({
  selectedClasses,
  setSelectedClasses,
  studentListFetching,
  onSearch,
  selectedStudentsCount,
  onPrint,
  totalStudents,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        alignItems={{ xs: "stretch", sm: "flex-end" }}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "end",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "400px", md: "300px" } }}>
            <ByClassFilter
              prevClassList={selectedClasses}
              setSelectedClasses={setSelectedClasses}
            />
          </Box>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            disabled={studentListFetching}
            onClick={onSearch}
            sx={{ mb: 0.5, textTransform: "capitalize" }}
          >
            Search
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 3,
            flexWrap: "wrap",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              mb: 1.5,
            }}
          >
            Total Students:{" "}
            <span style={{ fontSize: "18px" }}>{totalStudents || 0}</span>
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            disabled={selectedStudentsCount === 0}
            onClick={onPrint}
            sx={{ mb: 0.5, textTransform: "capitalize" }}
          >
            Print Certificates ({selectedStudentsCount})
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default CertificateHeader;
